export default __webpack_public_path__ + "static/media/Team2.e35141f8.jpg";